<template>
  <div class="bottom-nav">
    <div class="icons text-xl">
      <i v-if="!isPreview" class="icon icon-arrow-left clickable" @click="goBack($event)" />
      <image-overlay
        v-if="currentRadio.hasOwnProperty('landscapeImagePath') && currentRadio.landscapeImagePath && isPreview"
        :imagePath="`data:image/jpg;base64,${dataImage}`" />
      <image-overlay
        v-else-if="currentRadio.hasOwnProperty('landscapeImagePath') && currentRadio.landscapeImagePath && buildNumber"
        :imagePath="`${staticUrl}Images/${currentRadio.landscapeImagePath}` + '?' + buildNumber"
      />
      <div id="slideButtonGroup"
        v-if="currentRadio.hasOwnProperty('slides') && this.currentRadio.slides.length > 0">
        <slides-overlay :iconSlides="currentRadio.slides" :isPreview="isPreview" />
      </div>
      <pop-up
        v-if="currentRadio.hasOwnProperty('video') && hasVideo()"
        :isOffline="isOffline"
        :video="currentRadio.video"
        :videoUrl="currentRadio.video === null ? null : `${staticUrl}Videos/${currentRadio.video.fileName}`"
      />
      <a
        v-if="currentRadio.hasOwnProperty('dataSheetFilePath') && currentRadio.dataSheetFilePath && isPreview"
        @click="$emit('download')"
        class="icon icon-document color-text">
      </a>
      <a
        v-else-if="currentRadio.hasOwnProperty('dataSheetFilePath') && currentRadio.dataSheetFilePath && buildNumber"
        :href="
          `${staticUrl}Images/${currentRadio.dataSheetFilePath}` + '?' + buildNumber
        "
        :download="`${currentRadio.dataSheetFilePath}`"
        class="icon icon-document color-text"
      >
      </a>
    </div>
    <ul>
      <li
        v-for="radio in radios"
        :key="radio.fileName"
        @click="routerLink(radio)"
      >
        <div
          :class="[
            'nav-content',
            isActive(radio.fileName) ? 'active' : ''
          ]"
        >
          <span class="pre-formatted">{{ radio.alias || radio.name }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import PopUp from './PopupComponent.vue'
import PopUpImage from './PopupImageComponent.vue'
import OverlaySlides from './OverlaySlidesComponent.vue'
import { getStaticUrl } from '@/helpers';
import axios from 'axios';
import AssetsApiService from '@/services/assetsServices/assetsApiService';

export default {
  name: 'ProductsBottomNavComponent',
  components: {
    'pop-up': PopUp,
    'image-overlay': PopUpImage,
    'slides-overlay': OverlaySlides,
  },
  props: {
    radios: {
      type: Array
    },
    baseUrl: {
      type: String,
      default: '/'
    },
    prefix: {
      type: String
    },
    radio: {
      type: Object,
      require: true
    },
    section: {
      type: Object,
      require: true
    },
    currentRadio: {
      type: Object,
      require: true
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    image: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      buildNumber: 0,
      dataImage: ''
    };
  },
  computed: {
    isOffline() {
      return process.env.IS_ELECTRON;
    },
    staticUrl () {
      return getStaticUrl(this.radio, this.$route.name);
    }
  },
  watch: {
    image: async function() {
      if (this.isPreview) {
        await this.getImage();
      }
    }
  },
  async mounted() {
    axios.get(`${this.staticUrl}assetsConfig.json?` + Date.now()).then(result => {
      this.buildNumber = result.data.buildNumber;
    });

    if (this.isPreview) {
      await this.getImage();
    }
  },
  methods: {
    goBack() {
      if (this.$route.query.from && this.$route.query.from === 'showcase') {
        this.$router.push({
          name: this.$route.query.from,
          query: { activeTab: this.$route.query.activeTab }
        });
      } else if (this.$route.query.hasOwnProperty('activeSlide')) {
        this.$router.push(`/${this.$route.query.from}?activeSlide=${this.$route.query.activeSlide}`);
      } else {
        this.$router.go(-1);
      }
    },
    isActive(fileName) {
      return fileName === this.radio.fileName;
    },
    routerLink(radio) {
      this.$router.replace({ name: this.section.prefix, params: { product: radio.fileName } });
    },
    async getImage() {
      if (this.image !== null && this.image != '') {
        this.dataImage = await AssetsApiService.getAssetFile(this.image);
      }
    },
    hasVideo() {
      return (
        this.currentRadio.video &&
        ((this.currentRadio.video.wid != '' &&
        this.currentRadio.video.wid != null) ||
        (this.currentRadio.video.fileName != '' &&
        this.currentRadio.video.fileName != null))
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.bottom-nav {
  position: fixed;
  bottom: 0;
  right: @space-xl;
  left: @space-xxl;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: @space-large;
  .pre-formatted {
    white-space: pre;
  }
  .icons {
    display: flex;
    .icon {
      margin-right: @space-base;
      cursor: pointer;
    }
  }
  li {
    font-weight: 600;
    list-style: none;
    cursor: pointer;
    display: inline-block;
    color: @gray-42;
    display: table-cell;
    .nav-content {
      font-size: @font-size-sm;
      margin: 0 @space-small;
      padding: 0 0 @space-small 0;
      border-bottom: 2 / @px solid transparent;
      &.active {
        border-bottom-color: @white;
        color: @white;
        font-weight: normal;
      }
      &:hover {
        border-bottom-color: @white;
      }
    }
  }
  ul {
    padding: 0px;
    display: table-row;
    overflow-x: auto;
  }
}
</style>
